module.exports = __webpack_public_path__ + "static/media/Effra-Medium.965a3f4a.woff";